import React, { useEffect } from "react";
import { autorun } from "mobx";
import { observer } from "mobx-react-lite";
import { useStores } from "../../_stores";
import { FormControlLabel, Checkbox, Button, TextField, MenuItem } from "@material-ui/core";
import { settingStyles } from "./Styles/SettingStyles";
import { Notification } from '../../core/Notification';
import { useTranslation } from "react-i18next";
import Progress from "../../core/Progress";


const Settings = observer(() => {
    const {t} = useTranslation();
    const classes = settingStyles();
    const translate = (name: string) => t('setting.' + name);
    const {settingDownloadStore} = useStores();
    const {loadSettings, updateSetting, setting} = settingDownloadStore;
    

    const massTypeTime = [
        translate("names.minute"),
        translate("names.hour"),
        translate("names.day")];

    
    useEffect(() => {
        autorun(async () => {
            await loadSettings();
        });
    }, []);

    return(
        <div>
            <h2 className = {classes.title}>{translate("objects.setting")}</h2>
            <Progress isLoading = {settingDownloadStore.loading}/>
            <FormControlLabel
                className={classes.elementWrapper}
                control={<Checkbox
                        checked={setting.OfflineInstall} 
                onChange={(event) => setting.OfflineInstall = event.target.checked}
                />}
                label= {translate("objects.offline_update")}
            />
            <br/>
            <TextField
                disabled = {setting.OfflineInstall}
                className={classes.elementAddress}
                label={translate("objects.address")}
                value={setting.ServerAddress}
                onChange={(event) => setting.ServerAddress = event.target.value}
             />
            <br/>
            <h3>{translate("objects.period")}</h3>
            <TextField
                error = {Number(setting.TimeSleap) <= 0}
                disabled = {setting.OfflineInstall}
                className={classes.elementTime}
                label={translate("objects.time")}
                value={Number(setting.TimeSleap)}
                type = "number"
                onChange={(event) => setting.TimeSleap = event.target.value}
                helperText = {Number(setting.TimeSleap) <= 0 ? translate("notification.incorrect_time") : ""}
             />
            <TextField
                disabled = {setting.OfflineInstall}
                className={classes.elementTypeTime}
                select
                label={translate("objects.type_time")}
                value={settingDownloadStore.indexItem}
                onChange={(event) => settingDownloadStore.indexItem = Number(event.target.value)}
                >
                {massTypeTime.map((f, i) => <MenuItem key={i} value={i}>{f}</MenuItem>)}
            </TextField>
            <br/>
            <Button 
                className={classes.elementWrapper}
                variant="contained"
                size="medium"
                onClick={ async() => await updateSetting()}
            >
                {translate("objects.button_save")}
            </Button>
            {<Notification
                isOpen={settingDownloadStore.isNotification}
                close={() => settingDownloadStore.isNotification = false}
                okClick={() => settingDownloadStore.isNotification = false}
                questionText={settingDownloadStore.message}
            />}
        </div>
    );
});

export default Settings;